export default __webpack_public_path__ + "596969a5309a844ff7da2c499784a371.svg";